import { call, put, takeLatest } from 'redux-saga/effects';
import {
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_FAILURE,
  resetPasswordSuccess,
} from './actions';
import { push } from 'connected-react-router';
import { post } from '../../utils/api';
import swal from 'sweetalert';
import { handleApiError } from '../../utils/handleApiError';

function* resetPasswordRequest({ payload }) {
  try {
    yield call(
      post,
      '/forgot-password-reset',
      {
        password: payload.newPassword,
        confirmPassword: payload.confirmPassword,
        token: payload.token,
      },
      null
    );

    yield put(resetPasswordSuccess());
    yield call(swal, 'Success', 'Password reset successfully', 'success');
    yield put(push('/login'));
  } catch (error) {
    yield handleApiError(error, RESET_PASSWORD_FAILURE);
  }
}

export default [takeLatest(RESET_PASSWORD_REQUEST, resetPasswordRequest)];
